





import {
  Vue,
  Component
} from "@/shared/vuepack";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({ components: {} })
export default class RiskDisclaimer extends Vue {

  custodianSettingsStore = useCustodianSettingsStore();

  mounted (): void {
    this.custodianSettingsStore.getCustodianSettings({ username: null, partnerId: null, force: true });
  }

  get hasFooter (): boolean {
    return this.custodianSettingsStore.investmentRiskDisclaimer as any;
  }
}
